import { ApplicationRef, ComponentRef, createComponent, EmbeddedViewRef, EnvironmentInjector, Injectable } from '@angular/core';
import { LoadingComponent } from '../components/loading/loading.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private isInProgress: boolean = false;
  private componentRef?: ComponentRef<LoadingComponent>;

  constructor(
    private appRef: ApplicationRef,
    private environmentInjector: EnvironmentInjector
  ) { }

  start(): void {
    if (this.isInProgress) {
      return;
    }

    this.isInProgress = true;

    this.componentRef = createComponent(LoadingComponent, {
      environmentInjector: this.environmentInjector
    });

    this.appRef.attachView(this.componentRef.hostView);

    const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);
    document.body.classList.add('noscroll');
  }

  finish(): void {
    if (!this.isInProgress) {
      return;
    }

    this.isInProgress = false;

    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);

      this.componentRef.destroy();
      this.componentRef = undefined;
    }

    document.body.classList.remove('noscroll');
  }
}
